var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / ChartColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-20.5%",
    y: "-35.5%",
    width: "141.0%",
    height: "171.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0116365119%",
    y1: "50.0513721%",
    x2: "127.974263%",
    y2: "50.0513721%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0599996%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6499977%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.324186,15.7208545 C112.96598,7.99672132 95.427653,4.18009186 77.798456,4.18009186 L77.7075852,43.8912242 L77.6167145,75.6056042 L126.051567,103.594231 C139.137156,96.0518416 145.861699,86.2376479 146.316059,76.423455 L146.316059,44.6182008 C146.77042,34.167903 140.136753,23.7176043 126.324186,15.7208545 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-12.4%",
    y: "-8.6%",
    width: "124.7%",
    height: "117.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.0930581633%",
    y1: "49.9697584%",
    x2: "127.934897%",
    y2: "49.9697584%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0599996%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6499977%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0925965%",
    y1: "6.28571108%",
    x2: "82.9071239%",
    y2: "14.8571404%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "18.4609463%",
    x2: "99.999575%",
    y2: "24.6450746%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.7108836,44.7999667 L20.2760262,16.8113441 C6.91781969,24.5354772 0.193280815,34.6222866 0.0115365041,44.7090959 L0.0115365041,77.2413262 C0.10240866,87.237263 6.82694806,97.2332025 20.0034104,104.775591 C46.7198233,120.223858 90.2475796,120.132982 117.145738,104.593843 L117.145738,72.7885893 L68.7108836,44.7999667 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-7.3%",
    y: "-8.5%",
    width: "114.5%",
    height: "117.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.2762102,16.8113441 L68.711065,44.7999674 L117.14592,72.7885906 C90.2477614,88.3277296 46.8108804,88.4186055 20.0035945,72.9703391 C-6.80369144,57.5220726 -6.62194817,32.3504831 20.2762102,16.8113441 Z M77.7981004,4.18009186 C95.427298,4.18009186 112.965626,7.99672144 126.323832,15.7208548 C153.131118,31.1691217 152.949371,56.3407118 126.051213,71.7889786 L77.7072296,43.8912255 Z M70.2553607,-4.83278563e-06 L70.3462315,39.7111272 L21.9113712,11.7225027 C35.36045,3.9074971 52.7170359,-4.83278563e-06 70.2553607,-4.83278563e-06 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.8%",
    width: "102.1%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-ChartColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-113",
    transform: "translate(21.831055, 6.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.878416,112.778182 C96.310748,129.271733 49.9934122,129.271737 21.4257473,112.778187 C-7.14191765,96.2846372 -7.14191623,69.5433089 21.4257515,53.0497575 C49.9934193,36.556206 96.3107508,36.5562032 124.878416,53.0497532 C153.446081,69.5433033 153.446084,96.2846301 124.878416,112.778182 Z",
    id: "Ellipse-35",
    fill: "url(#linearGradient-1)",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.2553607,-4.83278563e-06 C52.7170359,-4.83278563e-06 35.36045,3.90749698 21.9113712,11.7225023 L21.9113712,43.527757 L70.3462315,71.5163755 L70.3462315,-4.83278563e-06 L70.2553607,-4.83278563e-06 Z",
    id: "Vector",
    fill: "url(#linearGradient-6)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Vector",
    fill: "url(#linearGradient-7)",
    points: "126.051567 71.8798883 77.7075852 43.9821396 77.6167145 75.696523 126.051567 103.685143"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-11)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartColor);
export default __webpack_public_path__ + "static/media/ChartColor.801733cfa20a29e1cbd6f25a0219d5ba.svg";
export { ForwardRef as ReactComponent };